// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuLabel_root__XfDq2","clickedWithMouse":"MenuLabel_clickedWithMouse__13PBy","isOpen":"MenuLabel_isOpen__2TZKA"};